<template>
    <div v-if="loader">
        <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    <div v-else-if="action == 'view'">
        <div class="table-settings mb-4" v-if="allData.data.length > 0">
            <div class="row align-items-center justify-content-between">
                <!-- <div class="col col-md-6 col-lg-3 col-xl-4">
                    <button style="margin-right:20px;" @click="allDatas('pending')" type="button" :class="orderStatus=='pending' ? 'active' : ''" class="btn btn-sm btn-outline-primary"><i class="fa fa-eye"></i> Pending</button>
                    <button @click="allDatas('complete')" type="button" :class="orderStatus=='complete' ? 'active' : ''" class="btn btn-sm btn-outline-primary"><i class="fa fa-plus"></i> Completed</button>
                </div> -->
                <div class="col-4 col-md-2 col-xl-1 pl-md-0 text-right">

                </div>
            </div>
        </div>
        <div class="card border-light shadow-sm mb-4">
            <div class="card-body" v-if="loading == false">
                <div style="position: absolute; margin-top: 100px; z-index: 1; width: max-content; left: 50%; transform: translate(-50%, 0%);"
                    v-if="!permissions.find(e => e.permission_name == 'View Orders')">
                    <span style="color: red;"><i class="mr-2 fa fa-eye-slash"></i>You dont have the viewing
                        permission.</span>
                </div>
                <div
                    :style="!permissions.find(e => e.permission_name == 'View Orders') ? 'filter: blur(4px); pointer-events: none;' : ''">
                    <div class="d-flex flex-row-reverse pb-3" style="gap: 10px;">
                        <button :disabled="!permissions.find(e => e.permission_name == 'Export Orders')"
                            @click.prevent="exportData" class="btn btn-sm btn-outline-primary"><i
                                class="fa fa-download mx-2"></i>EXPORT</button>
                        <input @input="search" v-model="order_id_for_serach" type="text"
                            placeholder="Search By Order ID" class="form-control w-25">
                        <div class="d-flex flex-row align-items-center" style="gap: 10px">
                            <span>Start Date: </span>
                            <input type="date" @input="filterByDate" v-model="start_date" class="form-control"
                                style="width: max-content;">
                        </div>
                        <div class="d-flex flex-row align-items-center" style="gap: 10px">
                            <span>End Date: </span>
                            <input type="date" @input="filterByDate" v-model="end_date" class="form-control"
                                style="width: max-content;">
                        </div>
                    </div>
                    <div v-if="loader">
                        <span class="loader"></span>
                    </div>
                    <div style="overflow-x: scroll;" v-if="!loader && allData.data.length > 0">
                        <table class="table table-hover">
                            <thead class="thead-light">
                                <tr>
                                    <th>#</th>
                                    <th>Ord ID</th>
                                    <th>Product</th>
                                    <th>Username</th>
                                    <th>Order Date</th>
                                    <th>Order Type</th>
                                    <th>Sub Total</th>
                                    <th>Coupon</th>
                                    <th>Coupon Amount</th>
                                    <th>Total Paid</th>
                                    <th>Order Address</th>
                                    <th>Payment Status</th>
                                    <th>Payment type</th>
                                    <th>Images</th>
                                    <th>Order Status</th>
                                    <th>Other Action</th>
                                </tr>
                            </thead>
                            <tbody v-if="allData.data.length > 0">
                                <template v-for="(data, key) in allData.data">
                                    <template v-if="data.order_details.length > 1">
                                        <tr :key="key">
                                            <td>
                                                <a @click.prevent="() => {
                                                    allData.data[key].collaps = !allData.data[key].collaps
                                                }" class="font-weight-bold d-flex align-items-center text-success"
                                                    style="user-select: none;">
                                                    {{ key + 1 }}
                                                    <i class="pl-1 font-weight-bold"
                                                        :class="data.collapsable && !data.collaps ? 'fa fa-angle-down' : data.collapsable && data.collaps ? 'fa fa-angle-up' : ''"></i>
                                                </a>
                                            </td>
                                            <td>
                                                {{ `SNP-ORD-${data.oid}` }}
                                            </td>
                                            <td class="text-center">
                                                <a @click.prevent="() => {
                                                    allData.data[key].collaps = !allData.data[key].collaps
                                                }" class="font-weight-bold d-flex align-items-center text-success"
                                                    style="user-select: none;">
                                                    View
                                                </a>
                                            </td>
                                            <td>
                                                {{ data.address.add_title || data.user.mobile || data.user.email ||
                                                    'N/A' }}
                                            </td>
                                            <td>{{ new Date(data.odate).toLocaleDateString() }}</td>
                                            <td class="text-center">
                                                <a @click.prevent="() => {
                                                    allData.data[key].collaps = !allData.data[key].collaps
                                                }" class="font-weight-bold d-flex align-items-center text-success"
                                                    style="user-select: none;">
                                                    View
                                                </a>
                                            </td>
                                            <td>
                                                {{ new Intl.NumberFormat('en-IN', {
                                                    style: 'currency',
                                                    currency: 'INR'
                                                }).format(canculateSubTotal(data.order_details)) }}
                                            </td>
                                            <td>
                                                {{ data.coupon || 'N/A' }}
                                            </td>
                                            <td>
                                                {{ new Intl.NumberFormat('en-IN', {
                                                    style: 'currency',
                                                    currency: 'INR'
                                                }).format(canculateSubTotal(data.order_details) - data.total) }}
                                            </td>
                                            <td>
                                                {{ new Intl.NumberFormat('en-IN', {
                                                    style: 'currency',
                                                    currency: 'INR'
                                                }).format(data.total || 0) }}
                                            </td>
                                            <td class="text-center">
                                                <a @click.prevent="() => {
                                                    allData.data[key].collaps = !allData.data[key].collaps
                                                }" class="font-weight-bold d-flex align-items-center text-success"
                                                    style="user-select: none;">
                                                    View
                                                </a>
                                            </td>
                                            <td>{{ data.status_payment }}</td>
                                            <td>{{ data.paymenttype }}</td>
                                            <td>
                                                <a @click.prevent="() => {
                                                    allData.data[key].collaps = !allData.data[key].collaps
                                                }" class="font-weight-bold d-flex align-items-center text-success"
                                                    style="user-select: none;">
                                                    View
                                                </a>
                                                <!-- <a class="btn btn-success btn-sm link" v-if="data.order_details && data.order_details.length > 1" @click="() => {
                                                    imageData = data.order_details
                                                    $modal.show('showModal12'+key+22)
                                                }"> View Files </a>
                                                <a v-else >
                                                    N/A
                                                </a>
                                                <Modal width="50%" height="500px" :name="'showModal12'+key+22">
                                                    <div class="modal-header">
                                                        <h3> Order Details </h3>
                                                        <hr>
                                                        <a class="close-btn" @click="$modal.hide('showModal12'+key+22)">Close</a>
                                                    </div>
                                                    <div style="height: 350px; overflow-y: auto;" class="d-flex flex-column p-4">
                                                        <div v-for="(images, index) in imageData" :key="index">
                                                            <div class="d-flex flex-row" style="width: 100%; overflow-x: auto; gap: 10px; border-radius: 10px; padding: 20px;">
                                                                <div v-for="(image, index) in images.images" :key="index" style="border: 1px solid black; border-radius: 10px;" class="d-flex flex-column">
                                                                    <a :href="image.image_url" download target="_blank" class="text-success p-2 "><i class="fa fa-download"></i></a>
                                                                    <img v-if="['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'webp'].includes(image.image_url.split('.')[image.image_url.split('.').length - 1])" :src="image.image_url" width="200" height="150" >
                                                                    <iframe v-else :src="image.image_url" style="border-radius: 10px;" frameborder="0"></iframe>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Modal> -->
                                            </td>
                                            <td>
                                                <span class="font-weight-bold">
                                                    <select
                                                        :disabled="!permissions.find(e => e.permission_name == 'Change Status')"
                                                        class="form-control" style="width: max-content;"
                                                        v-model="data.status_order"
                                                        @change="updateStatus(data.oid, data.status_order, data)">
                                                        <option :value="0">Pending </option>
                                                        <option :value="1">Order Placed</option>
                                                        <option :value="2">Order Packed</option>
                                                        <option :value="3">Order Shipped</option>
                                                        <option :value="4">Order Delivered</option>
                                                    </select>
                                                </span>
                                                <Modal class="lg" :name="`shipOrder${data.oid}`">
                                                    <div class="modal-header">
                                                        <h3>
                                                            Create order in Ship-Rocket
                                                        </h3>
                                                        <hr>
                                                        <a class="close-btn text-danger" @click="() => {
                                                            $modal.hide(`shipOrder${data.oid}`)
                                                            allDatas()
                                                        }"><i class="fa fa-times"></i></a>
                                                    </div>
                                                    <div class="card-body d-flex flex-row">
                                                        <div
                                                            style="width: 100% !important; height: 200px !important; overflow-y: scroll;">
                                                            <div class="d-flex  align-items-center">
                                                                <select v-model="orderType"
                                                                    class="form-control mx-2 px-2">
                                                                    <option selected value="small">SMALL</option>
                                                                    <option value="medium">MEDIUM</option>
                                                                    <option value="big">BIG</option>
                                                                </select>
                                                                <button class="btn btn-outline-success"
                                                                    @click.prevent="shipOrder(data)">Ship
                                                                    Order</button>
                                                            </div>
                                                            <div class="d-flex align-items-center py-2">
                                                                <h6 class="px-2">Order Id:</h6>
                                                                <input class="form-control" type="text" disabled
                                                                    v-model="selectedOrderForTelyport.oid">
                                                            </div>
                                                            <div class="d-flex flex-row"
                                                                v-for="(item, index) in selectedOrderForTelyport.order_details">
                                                                <div class="card w-100 p-3">
                                                                    <h5>
                                                                        <span
                                                                            v-if="item.selected_product && item.selected_product.product_category && typeof item.selected_product.product_category != 'string' && item.selected_product.product_category.category_name">
                                                                            {{
                                                                                item.selected_product.product_category.category_name
                                                                            }}
                                                                        </span>
                                                                        <span v-else>
                                                                            {{ item.name }}
                                                                        </span>
                                                                    </h5>
                                                                    <p>{{ item.qty }}</p>
                                                                    <p>{{ item.price }}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Modal>
                                            </td>
                                            <td></td>
                                        </tr>
                                        <tr v-if="data.collaps" v-for="(ord, ind) in data.order_details" :key="ind">
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <!-- <pre>{{ {
                                                    od_id: ord.oid, index: ind
                                                } }}</pre> -->
                                                <a class="d-flex align-items-center" @mouseenter="showTooltipIndex = {
                                                    od_id: ord.oid, index: ind
                                                }" @mouseleave="showTooltipIndex = null">
                                                    <span>
                                                        {{ ord.name }}
                                                    </span>
                                                    <i class="fa fa-eye px-3"></i>
                                                </a>
                                                <!-- <pre>{{ showTooltipIndex }}</pre> -->
                                                <div
                                                    v-if="showTooltipIndex && showTooltipIndex.od_id == ord.oid && showTooltipIndex.index == ind">
                                                    <div class="d-flex justify-content-between align-items-center"
                                                        v-for="(product_details, product_details_ind) in ord.selected_product.product_options"
                                                        :key="product_details_ind">
                                                        <span>{{ product_details.name }} :
                                                            {{ord.selected_product.product_option_values.find(e =>
                                                                e.opt_id == product_details.id).name}}</span>
                                                    </div>
                                                    <div class="d-flex justify-content-left align-items-center">
                                                        <span>Quantity</span> : <span>{{ ord.qty }}</span>
                                                    </div>
                                                    <div class="d-flex justify-content-left align-items-center">
                                                        <span>Price</span> : <span>{{ ord.price }}</span>
                                                    </div>
                                                </div>
                                                <!-- {{ ord.name }} -->
                                            </td>
                                            <td></td>
                                            <td>{{ new Date(data.odate).toLocaleDateString() }}</td>
                                            <td>{{ ord.order_type || 'N/A' }}</td>
                                            <td>
                                                <a class="btn btn-success btn-sm link" v-if="ord.address" @click="() => {
                                                    address_data = ord.address
                                                    $modal.show('addressModal' + key)
                                                }"> View Address </a>
                                                <Modal width="50%" height="500px" :name="'addressModal' + key">
                                                    <div style="height: 100%; overflow-y: auto;">
                                                    <div class="modal-header">
                                                        <h3>
                                                            Order Address
                                                        </h3>
                                                        <hr>
                                                        <a class="close-btn"
                                                            @click="$modal.hide('addressModal' + key)">Close</a>
                                                    </div>
                                                    <div class="card-body">
                                                        <div class="">
                                                            <address class="card " style="overflow-y: scroll;">
                                                                <p class="address-heading"><strong> {{ address_data ?
                                                                    address_data.add_title : 'N/A' }} </strong></p>
                                                                <p class="padding-card">{{ address_data ?
                                                                    address_data.add1
                                                                    : 'N/A' }} <br>
                                                                    {{ address_data ? address_data.add2 : 'N/A' }} <br>
                                                                    {{ address_data ? "Floor: " + address_data.floor :
                                                                        'N/A' }} <br>
                                                                    {{ address_data ? address_data.c_state : 'N/A' }},
                                                                    {{
                                                                        address_data ? address_data.city : 'N/A' }} <br>
                                                                    {{ address_data ? address_data.country : 'N/A' }} {{
                                                                        address_data ? address_data.zipcode : 'N/A' }} </p>
                                                                <a class="padding-card"
                                                                    style="padding-top: 0 !important; padding-bottom: 0 !important;"
                                                                    target="_blank"
                                                                    v-if="address_data && address_data.lat && address_data.lng">{{
                                                                        address_data ? "Address Type:"
                                                                            + address_data.address_type : 'N/A' }}</a>
                                                                <a class="padding-card"
                                                                    style="padding-top: 0 !important; padding-bottom: 0 !important; color: blue;"
                                                                    target="_blank"
                                                                    v-if="address_data && address_data.lat && address_data.lng"
                                                                    :href="createGoogleMapsLink(address_data.lat, address_data.lng, address_data)">Open
                                                                    Google Map Location</a>
                                                                <p class="padding-card">{{ address_data ?
                                                                    address_data.email
                                                                    : 'N/A' }} </p>
                                                                <p class="padding-card">{{ address_data ?
                                                                    address_data.mobile_no : 'N/A' }} </p>
                                                            </address>
                                                        </div>

                                                    </div>
                                                    </div>
                                                </Modal>
                                            </td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                                <!-- <pre>{{ord}}</pre> -->
                                                <a class="btn btn-success btn-sm link" v-if="ord.selected_product &&
                                                    ord.selected_product.product_images &&
                                                    ord.selected_product.product_images.length" @click="() => {
                                                        imageData = ord
                                                        $modal.show('showModal12' + key + 22)
                                                    }"> View Files </a>
                                                <a class="btn btn-success btn-sm link" v-else-if="ord.design_images"
                                                    @click="() => {
                                                        imageData = ord
                                                        $modal.show('showModal12' + key + 22)
                                                    }"> View Files </a>
                                                <a v-else>
                                                    N/A
                                                </a>
                                                <Modal width="50%" height="500px" :name="'showModal12' + key + 22">
                                                    <div class="modal-header">
                                                        <h3>
                                                            Order Details
                                                        </h3>
                                                        <hr>
                                                        <a class="close-btn"
                                                            @click="$modal.hide('showModal12' + key + 22)">Close</a>
                                                    </div>
                                                    <div style="height: 400px; overflow-y: scroll;">
                                                        <!-- <pre style="height: 300px; overflow-y: scroll;">{{ imageData }}</pre> -->
                                                        <div v-if="imageData" class="card-body d-flex flex-column">
                                                            <p v-if="imageData.name">Product: {{ imageData.name }}</p>
                                                            <p
                                                                v-else-if="imageData.selected_product && imageData.selected_product.product_category && imageData.selected_product.product_category.category_name">
                                                                Product: {{
                                                                    imageData.selected_product.product_category.category_name
                                                                }}</p>
                                                            <template
                                                                v-if="imageData.selected_product && imageData.selected_product.product_options">
                                                                <template
                                                                    v-if="imageData.selected_product.product_options.length && imageData.selected_product.product_option_values.length"
                                                                    v-for="(opt, opt_ind) in imageData.selected_product.product_options">
                                                                    <p :key="opt_ind">{{ opt.name }}: {{
                                                                        imageData.selected_product &&
                                                                            imageData.selected_product.product_option_values.find(e
                                                                                => e.opt_id == opt.id) ?
                                                                            imageData.selected_product.product_option_values.find(e
                                                                                => e.opt_id == opt.id).name : 'N/A'}}</p>
                                                                </template>
                                                            </template>
                                                            <p v-if="imageData.qty">Quatity: {{ imageData.qty }}</p>
                                                            <div v-if="imageData.design_images"
                                                                class="d-flex flex-column">
                                                                <span
                                                                    v-if="imageData.design_images.description">Description:
                                                                    {{
                                                                        imageData.design_images.description }}</span>
                                                                <span v-if="imageData.design_images.content_file"><a
                                                                        @click.prevent="downloadFile(imageData.design_images.content_file)"><i
                                                                            class="fa fa-download"></i>Content
                                                                        File</a></span>
                                                                <span v-if="imageData.design_images.logo"><a
                                                                        @click.prevent="downloadFile(imageData.design_images.logo)"><i
                                                                            class="fa fa-download"></i>Logo</a></span>
                                                                <span v-if="imageData.design_images.reference"><a
                                                                        @click.prevent="downloadFile(imageData.design_images.reference)"><i
                                                                            class="fa fa-download"></i>Reference
                                                                        File</a></span>
                                                            </div>
                                                            <div v-if="imageData && imageData.selected_product && imageData.selected_product.product_images && imageData.selected_product.product_images.length"
                                                                class="card border"
                                                                style="width: 100%; overflow-x: auto;">
                                                                <template
                                                                    v-for="(image, index) in imageData.selected_product.product_images">
                                                                    <a v-if="image && image.image_url"
                                                                        class="text-success p-2 " :key="index"
                                                                        @click.prevent="downloadFile(image.image_url)"><i
                                                                            class="fa fa-download mr-2"></i>{{
                                                                                image.image_url }}</a>
                                                                    <!-- <img :key="index" v-if="image && ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff', 'webp'].includes(image.image_url.split('.')[image.image_url.split('.').length - 1])"
                                                                        :src="image.image_url" width="200" height="150">
                                                                    <iframe :key="index" v-else :src="image.image_url"
                                                                        style="border-radius: 10px;" frameborder="0"></iframe> -->
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Modal>
                                            </td>
                                            <td></td>
                                            <td class="align-items-center">
                                                <button @click.prevent="openDesignModal(ord, `SNP-ORD-${ord.odid}`)"
                                                    v-if="ord.order_type != 'Print'"
                                                    style="width: max-content !important"
                                                    class="btn btn-outline-success"><i
                                                        class="fa fa-upload mr-2"></i>Upload</button>
                                                <Modal width="50%" height="500px" :name="`SNP-ORD-${ord.odid}`">
                                                    <div class="modal-header" v-if="order_details">
                                                        <h3>
                                                            Design Files For {{ order_details.name }}
                                                        </h3>
                                                        <hr>
                                                        <a class="text-danger close-btn"
                                                            @click.prevent="closeDesignModal(`SNP-ORD-${order_details.odid}`)">Close</a>
                                                    </div>
                                                    <div class="card-body d-flex flex-column"
                                                        style="gap: 10px; height: 400px; overflow-y: scroll;"
                                                        v-if="order_details">
                                                        <span>Order ID: {{ `SNP-ORD-${order_details.oid}` }}</span>
                                                        <input type="file" id="files" name="file" ref="files"
                                                            @change="handleFileChange" accept=".png, .jpg, .jpeg"
                                                            multiple>
                                                        <div class="d-flex flex-row"
                                                            style="gap: 10px; width: 100%; overflow-x: scroll;"
                                                            v-if="uploaded_files.length">
                                                            <div class="d-flex flex-column" style="gap: 8px"
                                                                v-for="(file, file_index) in uploaded_files"
                                                                :key="file_index">
                                                                <img width="100px" :src="file.file_url" alt="File">
                                                                <button class="btn btn-danger btn-xs"
                                                                    @click.prevent="removeImage(file_index)"><i
                                                                        class="fa fa-trash mr-2"></i>Delete</button>
                                                            </div>
                                                        </div>
                                                        <button @click.prevent="uploadDesignFilesAdmin"
                                                            class="btn btn-outline-success"><i
                                                                class="fa fa-upload mr-2"></i>Upload</button>
                                                    </div>
                                                </Modal>
                                            </td>
                                        </tr>
                                    </template>
                                    <template v-else-if="data.order_details.length == 1">
                                        <tr>
                                            <td>
                                                <a class="font-weight-bold" style="user-select: none;">
                                                    {{ key + 1 }}
                                                    <i class="font-weight-bold"
                                                        :class="data.collapsable && !data.collaps ? 'fa fa-angle-down' : data.collapsable && data.collaps ? 'fa fa-angle-up' : ''"></i>
                                                </a>
                                            </td>
                                            <td>
                                                {{ `SNP-ORD-${data.oid}` }}
                                            </td>
                                            <td>
                                                <!-- <pre>{{data.order_details[0]}}</pre> -->
                                                <a class="d-flex align-items-center"
                                                    @mouseenter="showTooltipIndex = key"
                                                    @mouseleave="showTooltipIndex = null">
                                                    <span
                                                        v-if="data.order_details[0].selected_product && data.order_details[0].selected_product.product_category && typeof data.order_details[0].selected_product.product_category != 'string' && data.order_details[0].selected_product.product_category.category_name">
                                                        {{
                                                            data.order_details[0].selected_product.product_category.category_name
                                                        }}
                                                    </span>
                                                    <span v-else>
                                                        {{ data.order_details[0].name }}
                                                    </span>
                                                    <i class="fa fa-eye px-3"></i>
                                                </a>
                                                <div v-if="showTooltipIndex == key">
                                                    <div class="d-flex justify-content-between align-items-center"
                                                        v-for="(product_details, product_details_ind) in data.order_details[0].selected_product.product_options"
                                                        :key="product_details_ind">
                                                        <span>{{ product_details.name }} :
                                                            {{data.order_details[0].selected_product.product_option_values.find(e
                                                                => e.opt_id == product_details.id).name}}</span>
                                                    </div>
                                                    <div class="d-flex justify-content-left align-items-center">
                                                        <span>Quantity</span> :
                                                        <span>{{ data.order_details[0].qty }}</span>
                                                    </div>
                                                    <div class="d-flex justify-content-left align-items-center">
                                                        <span>Price</span> :
                                                        <span>{{ data.order_details[0].price }}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>{{ data.address.add_title }}</td>
                                            <td>{{ new Date(data.odate).toLocaleDateString() }}</td>
                                            <td>{{ data.order_details[0].order_type || 'N/A' }}</td>
                                            <td>{{ new Intl.NumberFormat('en-IN', {
                                                style: 'currency',
                                                currency: 'INR'
                                            }).format(data.order_details[0].price || 0) }}</td>
                                            <td>{{ data.coupon || 'N/A' }}</td>
                                            <td>{{ new Intl.NumberFormat('en-IN', {
                                                style: 'currency',
                                                currency: 'INR'
                                            }).format(data.order_details[0].price - data.total || 0) }}</td>
                                            <td>{{ new Intl.NumberFormat('en-IN', {
                                                style: 'currency',
                                                currency: 'INR'
                                            }).format(data.total || 0) }}</td>
                                            <td>
                                                <a class="btn btn-success btn-sm link"
                                                    v-if="data.order_details[0].address" @click="() => {
                                                        address_data = data.order_details[0].address
                                                        $modal.show('addressModal' + key)
                                                    }"> View Address </a>
                                                <a v-else>
                                                    N/A
                                                </a>
                                                <Modal width="50%" height="500px" :name="'addressModal' + key">
                                                    <div style="height: 100%; overflow-y: auto;">
                                                    <div class="modal-header">
                                                        <h3>
                                                            Order Address
                                                        </h3>
                                                        <hr>
                                                        <a class="close-btn"
                                                            @click="$modal.hide('addressModal' + key)">Close</a>
                                                    </div>
                                                    <div class="card-body">
                                                        <div class="">
                                                            <address class="card " style="overflow-y: scroll;">
                                                                <p class="address-heading"><strong> {{ address_data ?
                                                                    address_data.add_title : 'N/A' }} </strong></p>
                                                                <p class="padding-card">{{ address_data ?
                                                                    address_data.add1
                                                                    : 'N/A' }} <br>
                                                                    {{ address_data ? address_data.add2 : 'N/A' }} <br>
                                                                    {{ address_data ? "Floor: " + address_data.floor :
                                                                        'N/A' }} <br>
                                                                    {{ address_data ? address_data.c_state : 'N/A' }},
                                                                    {{
                                                                        address_data ? address_data.city : 'N/A' }} <br>
                                                                    {{ address_data ? address_data.country : 'N/A' }} {{
                                                                        address_data ? address_data.zipcode : 'N/A' }} </p>
                                                                <a class="padding-card"
                                                                    style="padding-top: 0 !important; padding-bottom: 0 !important;"
                                                                    target="_blank"
                                                                    v-if="address_data && address_data.lat && address_data.lng">{{
                                                                        address_data
                                                                            ? "Address Type:"
                                                                            + address_data.address_type
                                                                            : 'N/A' }}</a>
                                                                <a class="padding-card"
                                                                    style="padding-top: 0 !important; padding-bottom: 0 !important; color: blue;"
                                                                    target="_blank"
                                                                    v-if="address_data && address_data.lat && address_data.lng"
                                                                    :href="createGoogleMapsLink(address_data.lat, address_data.lng, address_data)">Open
                                                                    Google Map Location</a>
                                                                <p class="padding-card">{{ address_data ?
                                                                    address_data.email
                                                                    : 'N/A' }} </p>
                                                                <p class="padding-card">{{ address_data ?
                                                                    address_data.mobile_no : 'N/A' }} </p>
                                                            </address>
                                                        </div>

                                                    </div>
                                                    </div>
                                                </Modal>
                                            </td>
                                            <td>{{ data.status_payment }}</td>
                                            <td>{{ data.paymenttype }}</td>
                                            <td>
                                                <!-- <pre>{{ data }}</pre> -->
                                                <a class="btn btn-success btn-sm link" v-if="data.order_details[0].selected_product &&
                                                    data.order_details[0].selected_product.product_images &&
                                                    data.order_details[0].selected_product.product_images.length"
                                                    @click="() => {
                                                        imageData = data.order_details[0].selected_product.product_images

                                                        $modal.show('showModal12' + key + 22)
                                                    }"> View Files </a>
                                                <a class="btn btn-success btn-sm link"
                                                    v-else-if="data.order_details.length == 1 && data.order_details[0].design_images"
                                                    @click="() => {
                                                        imageData = data.order_details[0].design_images
                                                        $modal.show('showModal12' + key + 22)
                                                    }"> View Files </a>
                                                <a class="btn btn-success btn-sm link"
                                                    v-else-if="data.order_details[0].images.length > 0" @click="() => {
                                                        imageData = data.order_details[0].images

                                                        $modal.show('showModal12' + key + 22)
                                                    }"> View Files </a>
                                                <a v-else>
                                                    N/A
                                                </a>
                                                <Modal width="50%" height="500px" :name="'showModal12' + key + 22">
                                                    <div class="modal-header">
                                                        <h3>
                                                            Order Details
                                                        </h3>
                                                        <hr>
                                                        <a class="close-btn"
                                                            @click="$modal.hide('showModal12' + key + 22)">Close</a>
                                                    </div>
                                                    <div class="d-flex flex-column"
                                                        style="overflow-x: auto; overflow-y: scroll !important; height: 400px !important;">
                                                        <p
                                                            v-if="data.order_details[0].selected_product && data.order_details[0].selected_product.product_category && typeof data.order_details[0].selected_product.product_category != 'string' && data.order_details[0].selected_product.product_category.category_name">
                                                            Product: {{
                                                                data.order_details[0].selected_product.product_category.category_name
                                                            }}</p>
                                                        <div v-if="data.order_details[0].order_type == 'DESIGN'"
                                                            class="d-flex flex-column">
                                                            <span
                                                                v-if="data.order_details[0].design_images.description">Description:
                                                                {{ data.order_details[0].design_images.description
                                                                }}</span>
                                                            <span
                                                                v-if="data.order_details[0].design_images.content_file"><a
                                                                    @click.prevent="downloadFile(data.order_details[0].design_images.content_file)"><i
                                                                        class="fa fa-download"></i>Content
                                                                    File</a></span>
                                                            <span v-if="data.order_details[0].design_images.logo"><a
                                                                    @click.prevent="downloadFile(data.order_details[0].design_images.logo)"><i
                                                                        class="fa fa-download"></i>Logo</a></span>
                                                            <span
                                                                v-if="data.order_details[0].design_images.reference"><a
                                                                    @click.prevent="downloadFile(data.order_details[0].design_images.reference)"><i
                                                                        class="fa fa-download"></i>Reference
                                                                    File</a></span>
                                                        </div>
                                                        <div v-else-if="data.order_details[0].selected_product.product_images.length"
                                                            class="card border"
                                                            v-for="(image, index) in data.order_details[0].selected_product.product_images"
                                                            :key="'product_image' + index"
                                                            style="height: 350px; width: 100%; overflow-x: auto;">
                                                            <a v-if="image && image.image_url" class="text-success p-2 "
                                                                @click.prevent="downloadFile(image.image_url)"><i
                                                                    class="fa fa-download mr-2"></i>{{ image.image_url
                                                                    }}</a>
                                                        </div>
                                                        <div v-else-if="typeof data.order_details[0].images != 'string' && data.order_details[0].images.length"
                                                            class="card border"
                                                            v-for="(image, index) in data.order_details[0].images"
                                                            :key="'images' + index"
                                                            style="height: 350px; width: 100%; overflow-x: auto;">
                                                            <a v-if="image && image.image_url" class="text-success p-2 "
                                                                @click.prevent="downloadFile(image.image_url)"><i
                                                                    class="fa fa-download mr-2"></i>{{ image &&
                                                                        image.image_url }}</a>
                                                        </div>
                                                    </div>
                                                </Modal>
                                            </td>
                                            <td>
                                                <span class="font-weight-bold">
                                                    <select
                                                        :disabled="!permissions.find(e => e.permission_name == 'Change Status')"
                                                        class="form-control" style="width: max-content;"
                                                        v-model="data.status_order"
                                                        @change="updateStatus(data.oid, data.status_order, data)">
                                                        <option :value="0">Pending </option>
                                                        <option :value="1">Order Placed</option>
                                                        <option :value="2">Order Packed</option>
                                                        <option :value="3">Order Shipped</option>
                                                        <option :value="4">Order Delivered</option>
                                                    </select>
                                                </span>
                                                <Modal class="lg" :name="`shipOrder${data.oid}`">
                                                    <div class="modal-header">
                                                        <h3>
                                                            Create order in Ship-Rocket
                                                        </h3>
                                                        <hr>
                                                        <a class="close-btn text-danger" @click="() => {
                                                            $modal.hide(`shipOrder${data.oid}`)
                                                            allDatas()
                                                        }"><i class="fa fa-times"></i></a>
                                                    </div>
                                                    <div class="card-body d-flex flex-row p-3">
                                                        <div
                                                            style="width: 100% !important; height: 200px !important; overflow-y: scroll;">
                                                            <div class="d-flex  align-items-center">
                                                                <select v-model="orderType"
                                                                    class="form-control mx-2 px-2">
                                                                    <option selected value="small">SMALL</option>
                                                                    <option value="medium">MEDIUM</option>
                                                                    <option value="big">BIG</option>
                                                                </select>
                                                                <button class="btn btn-outline-success"
                                                                    @click.prevent="shipOrder(data)">Ship
                                                                    Order</button>
                                                            </div>
                                                            <div class="d-flex align-items-center py-2">
                                                                <h6 class="px-2">Order Id:</h6>
                                                                <input class="form-control" type="text" disabled
                                                                    v-model="selectedOrderForTelyport.oid">
                                                            </div>
                                                            <div class="d-flex flex-row"
                                                                v-for="(item, index) in selectedOrderForTelyport.order_details">
                                                                <div class="card w-100 p-3">
                                                                    <h5>Product Name: <span
                                                                            v-if="item.selected_product && item.selected_product.product_category && typeof item.selected_product.product_category != 'string' && item.selected_product.product_category.category_name">
                                                                            {{
                                                                                item.selected_product.product_category.category_name
                                                                            }}
                                                                        </span>
                                                                        <span v-else>
                                                                            {{ item.name }}
                                                                        </span>
                                                                    </h5>
                                                                    <p>Quantity: {{ item.qty }}</p>
                                                                    <p>Price: {{
                                                                        Number(item.price).toLocaleString('en-IN', {
                                                                            style: 'currency',
                                                                            currency: 'INR'
                                                                        }) }}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Modal>
                                            </td>
                                            <td class="align-items-center">
                                                <button
                                                    @click.prevent="openDesignModal(data.order_details[0], `SNP-ORD-${data.order_details[0].odid}`)"
                                                    v-if="data.order_details[0].order_type != 'Print'"
                                                    style="width: max-content !important"
                                                    class="btn btn-outline-success"><i
                                                        class="fa fa-upload mr-2"></i>Upload</button>
                                                <Modal width="50%" height="500px"
                                                    :name="`SNP-ORD-${data.order_details[0].odid}`">
                                                    <div class="modal-header" v-if="order_details">
                                                        <h3>
                                                            Design Files For {{ order_details.name }}
                                                        </h3>
                                                        <hr>
                                                        <a class="text-danger close-btn"
                                                            @click.prevent="closeDesignModal(`SNP-ORD-${order_details.odid}`)">Close</a>
                                                    </div>
                                                    <div class="card-body d-flex flex-column"
                                                        style="gap: 10px; height: 100%; overflow-y: scroll;"
                                                        v-if="order_details">
                                                        <span>Order ID: {{ `SNP-ORD-${order_details.oid}` }}</span>
                                                        <div class="d-flex flex-row pb-2 justify-content-center"
                                                            style="gap: 10px">
                                                            <div class="d-flex flex-row align-items-center"
                                                                style="gap: 10px">
                                                                <div style="
                                                                        border: 2px solid white;
                                                                        width: 15px !important;
                                                                        height: 15px !important;
                                                                        border-radius: 50% !important;
                                                                        background: green !important;
                                                                    "></div>
                                                                <span>Accepted by customer</span>
                                                            </div>
                                                            <div class="d-flex flex-row align-items-center"
                                                                style="gap: 10px">
                                                                <div style="
                                                                        border: 2px solid white;
                                                                        width: 15px !important;
                                                                        height: 15px !important;
                                                                        border-radius: 50% !important;
                                                                        background: red !important;
                                                                    "></div>
                                                                <span>Rejected by customer</span>
                                                            </div>
                                                            <div class="d-flex flex-row align-items-center"
                                                                style="gap: 10px">
                                                                <div style="
                                                                        border: 2px solid white;
                                                                        width: 15px !important;
                                                                        height: 15px !important;
                                                                        border-radius: 50% !important;
                                                                        background: DodgerBlue !important;
                                                                    "></div>
                                                                <span>Customer approval pending</span>
                                                            </div>
                                                        </div>
                                                        <input type="file" id="files" name="file" ref="files"
                                                            @change="handleFileChange" accept=".png, .jpg, .jpeg"
                                                            multiple>
                                                        <div class="d-flex flex-row"
                                                            style="gap: 10px; width: 100%; overflow-x: scroll;"
                                                            v-if="uploaded_files.length">
                                                            <div class="d-flex flex-column" style="gap: 8px"
                                                                v-for="(file, file_index) in uploaded_files"
                                                                :key="file_index">
                                                                <div style="
                                                                        position: absolute !important;
                                                                        margin-left: -5px !important;
                                                                        margin-top: -5px !important;
                                                                        border: 2px solid white;
                                                                        width: 15px !important;
                                                                        height: 15px !important;
                                                                        border-radius: 50% !important;
                                                                    "
                                                                    :style="file.accepted == true ? 'background: green !important' : file.accepted == false ? 'background: red !important' : 'background: DodgerBlue !important'">
                                                                </div>
                                                                <img width="130px" :src="file.file_url" alt="File">
                                                                <button class="btn btn-danger btn-xs"
                                                                    @click.prevent="removeImage(file_index)"><i
                                                                        class="fa fa-trash mr-2"></i>Delete</button>
                                                            </div>
                                                        </div>
                                                        <button @click.prevent="uploadDesignFilesAdmin"
                                                            class="btn btn-outline-success"><i
                                                                class="fa fa-upload mr-2"></i>Upload</button>
                                                    </div>
                                                </Modal>
                                            </td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                            <tbody v-else>
                                <tr>
                                    <td class="text-center" colspan="5">No record found</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="card-body text-center" v-else>
                <div v-if="loading">
                    loading...
                </div>
                <div v-else>
                    <!-- <InlineSvg name="nopage"></InlineSvg> -->
                    <div>
                        <h3>Add and manage your {{ page }}</h3>
                        <p>This is where you’ll add {{ page }} and manage your website. You can also improve your seo
                            for
                            {{ page }} by adding.</p>
                        <router-link :to="{ name: 'index', params: { page: page, action: 'add' } }"
                            class="btn btn-primary" type="button">Add {{ page }}</router-link>
                        <br><br><br>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="row">
            <div class="col-12 col-xl-8">
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">General information </h2>
                    <div class="row">
                        <!-- <div class="col-md-6 mb-3">
                                <MssInput v-model="form.linkname" placeholder="Enter Page Link" required></MssInput>
                            </div> -->
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.username" placeholder="Enter Fullname" required></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.mobile" placeholder="Enter Mobile Number" required></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.email" placeholder="Enter Mobile Email" required></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.pass" placeholder="Enter password" required></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.state" placeholder="Enter State name" required></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.city" placeholder="Enter City Name" required></MssInput>
                        </div>
                        <div class="col-md-6 mb-3">
                            <MssInput v-model="form.zip" placeholder="Enter Pincode" required></MssInput>
                        </div>

                    </div>
                </div>
            </div>
            <div class="col-12 col-xl-4 sidebar-stricky">
                <div class="card card-body bg-white border-light shadow-sm mb-4">
                    <h2 class="h5 mb-4">Visibility</h2>
                    <div class="row">
                        <div class="col-md-12 mb-3">
                            <MssInput type="switch" v-model="form.status" placeholder="Visible this page to all">
                            </MssInput>
                        </div>
                        <div class="col-md-12 mb-3">
                            <div>
                                <button @click="submit" class="btn btn-info btn-block"
                                    v-if="action == 'add'">Publish</button>
                                <button @click="submit" class="btn btn-success btn-block" v-else>Update</button>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import $ from 'jquery'

export default {
    components: {},
    props: [
        "page", "action", "id"
    ],
    data() {
        return {
            showTooltipIndex: -1,
            start_date: null,
            end_date: this.formatDate(new Date()),
            loader: false,
            order_id_for_serach: '',
            orderType: 'small',
            export_data: [],
            export_data_length: 0,
            export_heading: [
                'Order Type',
                'Customer Name',
                'Order Date',
                'Order Address Title',
                'Order Address-1',
                'Order Address-2',
                'Order City',
                'Order State',
                'Order Country',
                'Order ZIPCODE',
                'Payment Status',
                'Payment Type',
                'Order Status',
                'Order Price',
                'Order Quantity',
                'Order Product'
            ],
            changeStatusData: null,
            selectedOrderForTelyport: {},
            orderStatuses: [
                { id: 0, text: "Pending" },
                { id: 1, text: "Order Placed" },
                { id: 2, text: "Order Packed" },
                { id: 3, text: "Order Shipped" },
                { id: 4, text: "Order Delivered" },
            ],
            showModal: false,
            address_data: {},
            imageData: {},
            isEditor: true,
            q: '',
            getStatus: 0,
            orderStatus: 'complete',
            loading: false,
            allData: [],
            form: {
                id: null,
                status: true,
                type: 'add_user',
                username: '',
                email: '',
                mobile: '',
                password: '',
                state: '',
                city: '',
                zip: '',
            },
            editSEO: false,
            defaultSEO: true,
            pageList: [],
            fullToolbar: [
                [{
                    'font': []
                }],
                [{
                    'header': [false, 1, 2, 3, 4, 5, 6,]
                }],
                [{
                    'size': ['small', false, 'large', 'huge']
                }],
                ['bold', 'italic', 'underline', 'strike'],
                [{
                    'align': [false, 'justify', 'center', 'right']
                }],
                //[{ 'header': 1 }, { 'header': 2 }],
                //['blockquote', 'code-block'],
                [{
                    'list': 'ordered'
                }, {
                    'list': 'bullet'
                }, {
                    'list': 'check'
                }],
                //[{ 'script': 'sub'}, { 'script': 'super' }],
                [{
                    'indent': '-1'
                }, {
                    'indent': '+1'
                }],
                [{
                    'color': []
                }, {
                    'background': []
                }],
                ['link', 'image', 'video', 'formula'],
                //[{ 'direction': 'rtl' }],
                ['clean'],
            ],
            viewAllUrl: '',
            debounce_timer: null,
            tempData: [],
            permissions: null,
            order_details: null,
            file_loading: true,
            uploaded_files: [],
            files: null
        }
    },
    methods: {
        async uploadDesignFilesAdmin() {
            try {
                if (!this.files) {
                    this.$toasted.global.error({ message: 'Please select at least one file' });
                    return
                }
                this.files.delete('order_details')
                this.files.delete('files_count')
                this.files.append('order_details', this.order_details.odid)
                this.files.append('files_count', this.uploaded_files.length)
                const response = await axios({
                    method: "post",
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php?type=upload_design_files_for_order',
                    data: this.files
                })
                this.$toasted.global[response.data.status]({
                    message: response.data.message
                })
            } catch (error) {
                console.log(error)
            }
        },
        async removeImage(index) {
            if (this.uploaded_files[index].id) {
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php?type=delete_design_files_for_order',
                    data: {
                        file_id: this.uploaded_files[index].id
                    }
                })
                this.$toasted.global[response.data.status]({
                    message: response.data.message
                })
            } else {
                this.files.delete(`file${index + 1}`)
            }
            this.uploaded_files.splice(index, 1)
        },
        openDesignModal(data, modal) {
            this.uploaded_files = data.order_design_images.map(e => {
                return {
                    id: e.id,
                    file_url: e.file_url,
                    accepted: e.accepted
                }
            })
            this.order_details = data
            this.$modal.show(modal)
        },
        closeDesignModal(modal) {
            this.order_details = null
            this.$modal.hide(modal)
            this.files = null
            this.viewInit()
        },
        handleFileChange(event) {
            this.files = new FormData()
            let i = 0
            for (const file of event.target.files) {
                this.files.append(`file${i + 1}`, file)
                this.uploaded_files.push({ id: null, file_url: URL.createObjectURL(file), accepted: null })
                i = i + 1
            }
        },
        canculateSubTotal(order_details) {
            let sub_total = 0
            order_details.forEach(e => {
                sub_total = sub_total + e.price
            })
            return sub_total
        },
        filterByDate() {
            const ev = this
            const startDate = new Date(ev.start_date)
            const endDate = new Date(ev.end_date)
            ev.loader = true
            let data = []
            const new_data = [...ev.tempData.data]
            if (startDate || endDate) {
                data = new_data.map(e => {
                    const order_date = new Date(e.odate)
                    if (startDate != 'Invalid Date' && endDate) {
                        if (startDate <= order_date && endDate >= order_date) return e
                    } else if (endDate && startDate == 'Invalid Date') {
                        if (endDate >= order_date) return e
                    } else if (startDate != 'Invalid Date') {
                        if (startDate <= order_date) return e
                    }
                    return null
                })
            } else {
                data = new_data
            }
            ev.allData.data = data.filter(e => e != null)
            ev.export_data = []
            data.filter(e => e != null).forEach(async (element) => {
                const data = element.order_details.map(item => {
                    console.log(item);
                    if (item.order_type == 'Print' || item.order_type == 'DesignNPrint') {
                        let data = [
                            item.order_type ? item.order_type : 'N/A',
                            element.user.fullname ? element.user.fullname : 'N/A',
                            new Date(element.odate).toLocaleDateString(),
                            item.address.add_title ? item.address.add_title : 'N/A',
                            item.address.add1 ? item.address.add1.replaceAll(',', '-') : 'N/A',
                            item.address.add2 ? item.address.add2.replaceAll(',', '-') : 'N/A',
                            item.address.city ? item.address.city : 'N/A',
                            item.address.c_state ? item.address.c_state : 'N/A',
                            item.address.country ? item.address.country : 'N/A',
                            item.address.zipcode ? item.address.zipcode : 'N/A',
                            element.status_payment ? element.status_payment : 'N/A',
                            element.paymenttype ? element.paymenttype : 'N/A',
                            ev.orderStatuses.find(e => e.id == element.status_order).text ? ev.orderStatuses.find(e => e.id == element.status_order).text : 'N/A',
                            `₹ ${parseFloat(item.price ? item.price : 0).toFixed(2)}`,
                            `${item.qty ? item.qty : 0}`,
                            item.selected_product &&
                                item.selected_product.product_sub_category &&
                                item.selected_product.product_sub_category.sub_category_name
                                ? item.selected_product.product_sub_category.sub_category_name
                                : item.selected_product &&
                                    item.selected_product.product_category &&
                                    item.selected_product.product_category.category_name
                                    ? item.selected_product.product_category.category_name
                                    : 'N/A'
                        ]
                        item?.selected_product?.product_options?.forEach(e => {
                            data.push(`${e.name}: ${item.selected_product.product_option_values.find(el => el.opt_id == e.id).name}`)
                        })
                        ev.export_data_length = data.length > ev.export_data_length ? data.length : ev.export_data_length
                        return data
                    } else {
                        let data = [
                            item.order_type ? item.order_type : 'N/A',
                            element.user.fullname ? element.user.fullname : 'N/A',
                            new Date(element.odate).toLocaleDateString(),
                            item.address.add_title ? item.address.add_title : 'N/A',
                            item.address.add1 ? item.address.add1.replaceAll(',', '-') : 'N/A',
                            item.address.add2 ? item.address.add2.replaceAll(',', '-') : 'N/A',
                            item.address.city ? item.address.city : 'N/A',
                            item.address.c_state ? item.address.c_state : 'N/A',
                            item.address.country ? item.address.country : 'N/A',
                            item.address.zipcode ? item.address.zipcode : 'N/A',
                            element.status_payment ? element.status_payment : 'N/A',
                            element.paymenttype ? element.paymenttype : 'N/A',
                            ev.orderStatuses.find(e => e.id == element.status_order).text ? ev.orderStatuses.find(e => e.id == element.status_order).text : 'N/A',
                            `₹ ${parseFloat(item.price ? item.price : 0).toFixed(2)}`,
                            `${item.qty ? item.qty : 0}`,
                            item.selected_product.product_sub_category ? item.selected_product.product_sub_category.sub_category_name : item.selected_product.product_category.category_name
                        ]
                        ev.export_data_length = data.length > ev.export_data_length ? data.length : ev.export_data_length
                        return data
                    }
                })
                const mappedData = await Promise.all(data)
                ev.export_data.push(...mappedData)
            })
            ev.loader = false
        },
        createGoogleMapsLink(latitude, longitude, add) {
            // Construct the Google Maps URL with the latitude and longitude
            return `https://www.google.com/maps?q=${latitude},${longitude}${add ? ", " + add.add1 : ''}`;
        },
        formatDate(today) {
            const year = today.getFullYear();
            const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const day = String(today.getDate()).padStart(2, '0');
            const formattedDate = `${year}-${month}-${day}`;
            return formattedDate
        },
        search() {
            const ev = this
            clearTimeout(this.debounce_timer)
            this.debounce_timer = setTimeout(() => {
                ev.loader = true
                let data = []
                const new_data = [...ev.tempData.data]
                if (ev.order_id_for_serach != '') {
                    data = new_data.map(e => {
                        if (`SNP-ORD-${e.oid}`.toLowerCase().includes(ev.order_id_for_serach)) {
                            return e
                        }
                        return null
                    })
                } else {
                    data = new_data
                }
                ev.allData.data = data.filter(e => e != null)
                ev.export_data = []
                data.filter(e => e != null).forEach(async (element) => {
                    const data = element.order_details.map(item => {
                        if (item.order_type == 'Print' || item.order_type == 'DesignNPrint') {
                            return [
                                item.order_type ? item.order_type : 'N/A',
                                element.user.fullname ? element.user.fullname : 'N/A',
                                new Date(element.odate).toLocaleDateString(),
                                item.address.add_title ? item.address.add_title : 'N/A',
                                item.address.add1 ? item.address.add1.replaceAll(',', '-') : 'N/A',
                                item.address.add2 ? item.address.add2.replaceAll(',', '-') : 'N/A',
                                item.address.city ? item.address.city : 'N/A',
                                item.address.c_state ? item.address.c_state : 'N/A',
                                item.address.country ? item.address.country : 'N/A',
                                item.address.zipcode ? item.address.zipcode : 'N/A',
                                element.status_payment ? element.status_payment : 'N/A',
                                element.paymenttype ? element.paymenttype : 'N/A',
                                ev.orderStatuses.find(e => e.id == element.status_order).text ? ev.orderStatuses.find(e => e.id == element.status_order).text : 'N/A',
                                `₹ ${parseFloat(item.price ? item.price : 0).toFixed(2)}`,
                                `${item.qty ? item.qty : 0}`
                            ]
                        } else {
                            return [
                                item.order_type ? item.order_type : 'N/A',
                                element.user.fullname ? element.user.fullname : 'N/A',
                                new Date(element.odate).toLocaleDateString(),
                                item.address.add_title ? item.address.add_title : 'N/A',
                                item.address.add1 ? item.address.add1.replaceAll(',', '-') : 'N/A',
                                item.address.add2 ? item.address.add2.replaceAll(',', '-') : 'N/A',
                                item.address.city ? item.address.city : 'N/A',
                                item.address.c_state ? item.address.c_state : 'N/A',
                                item.address.country ? item.address.country : 'N/A',
                                item.address.zipcode ? item.address.zipcode : 'N/A',
                                element.status_payment ? element.status_payment : 'N/A',
                                element.paymenttype ? element.paymenttype : 'N/A',
                                ev.orderStatuses.find(e => e.id == element.status_order).text ? ev.orderStatuses.find(e => e.id == element.status_order).text : 'N/A',
                                `₹ ${parseFloat(item.price ? item.price : 0).toFixed(2)}`,
                                `${item.qty ? item.qty : 0}`
                            ]
                        }
                    })
                    const mappedData = await Promise.all(data)
                    ev.export_data.push(...mappedData)
                })
                ev.loader = false
            }, 300);
        },
        async shipOrder(order) {
            const ev = this
            console.log('Order.vue @ Line 1250:', order);
            // const orderPayload = {
            //     businessOrderID: `${order.oid}`,
            //     orderType: "SEND",
            //     pack: {
            //         type: this.orderType
            //     },
            //     dropAddress: JSON.parse(order.address_lat_lng),
            //     pickAddress: {
            //         lat: 12.891509052763213,
            //         lng: 77.61317488518421
            //     },
            //     receiver: {
            //         mobileNumber: order.address.mobile_no,
            //         name: order.user.fullname
            //     },
            //     sender: {
            //         mobileNumber: "8095135601",
            //         name: "ShapeNPrint"
            //     },
            //     shipType: 'XPRESS',
            //     walletType: "business"
            // }
            const packageSizes = {
                "small": {
                    "length": 9,
                    "breadth": 5,
                    "height": 1,
                    "weight": 0.1
                },
                "medium": {
                    "length": 25,
                    "breadth": 20,
                    "height": 10,
                    "weight": 2
                },
                "big": {
                    "length": 50,
                    "breadth": 40,
                    "height": 30,
                    "weight": 8
                }
            };
            const orderPayload = {
                "order_id": `SNP-${new Date().getTime()}-${order.oid}`,
                "order_date": new Date().toISOString().slice(0, 10),
                "pickup_location": "sNp",
                "billing_customer_name": order.address?.add_title,
                "billing_last_name": order.address?.add_title.split(' ').pop(),
                "billing_address": order.address?.add1,
                "billing_city": order.address?.city,
                "billing_pincode": order.address?.zipcode,
                "billing_state": order.address?.c_state,
                "billing_country": order.address?.country,
                "billing_email": order.address?.email,
                "billing_phone": order.address?.mobile_no,
                "shipping_is_billing": true,
                "company_name": "ShapeNPrint",
                "order_items": order.order_details.map(e => {
                    return {
                        "name": e.selected_product && e.selected_product.product_category && typeof e.selected_product.product_category != 'string' && e.selected_product.product_category.category_name ? e.selected_product.product_category.category_name : e.name,
                        "sku": `$${e.pid}#${e.selected_product.cat_id}`,
                        "units": e.qty,
                        "selling_price": e.price,
                        "discount": 0,
                        "tax": 0,
                        "hsn": Number(`${e.pid}${e.selected_product.cat_id}`),
                    }
                }),
                "payment_method": "Online",
                "shipping_charges": 0,
                "giftwrap_charges": 0,
                "transaction_charges": 0,
                "total_discount": 0,
                "sub_total": order.total,
                "length": packageSizes[this.orderType].length,
                "breadth": packageSizes[this.orderType].breadth,
                "height": packageSizes[this.orderType].height,
                "weight": packageSizes[this.orderType].weight,
            }
            console.log('Order.vue @ Line 1292:', orderPayload);
            axios.post(this.$root.SHIPROCKET_ROOT + '/token', {
                "email": this.$root.SHIPROCKET_EMAIL,
                "password": this.$root.SHIPROCKET_PASSWORD
            }).then((response) => {
                const token = response.data.token
                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: this.$root.SHIPROCKET_ROOT + '/create-order?token=' + token,
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: JSON.stringify(orderPayload)
                };
                axios(config)
                    .then((response) => {
                        console.log('Order.vue @ Line 1299:', response);
                        const telyportOrderId = response.data.order_id
                        let config = {
                            method: 'post',
                            maxBodyLength: Infinity,
                            url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            data: JSON.stringify({
                                type: 'addTelyportIdInOrderDetails',
                                oid: order.oid,
                                telyport_order_id: telyportOrderId
                            })
                        };
                        axios(config)
                            .then((response) => {
                                ev.$toasted.global[response.data.status]({
                                    message: response.data.msg
                                })
                                ev.$modal.hide(`shipOrder${order.oid}`)
                                ev.updateStatus(ev.changeStatusData.id, ev.changeStatusData.status, ev.changeStatusData.orderData)
                            })
                    })
            })
        },
        // async downlaodPrintAndDesignAndPrint(alldata) { 
        //     console.log(alldata);
        //     return
        //     const orderStatus = this.orderStatus
        //     let max_image_length = 0
        //     alldata.forEach(e => {
        //         if (max_image_length < e.images.length) {
        //             max_image_length = e.images.length
        //         }
        //     })
        //     let headings = [
        //         'Customer Name',
        //         'Order Date',
        //         'Order Address Title',
        //         'Order Address-1',
        //         'Order Address-2',
        //         'Order City',
        //         'Order State',
        //         'Order Country',
        //         'Order ZIPCODE',
        //         'Payment Status',
        //         'Payment Type',
        //         'Order Status',
        //         'Order Price',
        //         'Order Quantity'
        //     ]
        //     for (let i = 0; i < max_image_length; i++) {
        //         headings.push(`Product Image-${i+1}`)
        //     }
        //     const formattedData = alldata.filter(e => e.order_type != 'DESIGN').map(e => {
        //         let order_data = [
        //             e.user.username,
        //             new Date(e.order.odate).toLocaleDateString(),
        //             e?.address?.add_title ? e?.address?.add_title : 'N/A',
        //             e?.address?.add1 ? e?.address?.add1 : 'N/A',
        //             e?.address?.add2 ? e?.address?.add2 : 'N/A',
        //             e?.address?.city ? e?.address?.city : 'N/A',
        //             e?.address?.c_state ? e?.address?.c_state : 'N/A',
        //             e?.address?.country ? e?.address?.country : 'N/A',
        //             e?.address?.zipcode ? e?.address?.zipcode : 'N/A',
        //             e.order.status_payment,
        //             e.order.paymenttype,
        //             orderStatus.find(elm => elm.id == e.order.status_order).text,
        //             e.price,
        //             e.qty,
        //         ]
        //         e.images.forEach(el => {
        //             order_data.push(el.image_url)
        //         })
        //         return order_data
        //     })
        //     const csvData = await Promise.all(formattedData)
        //     let csvContent = 'data:text/csv;charset=utf-8,';
        //     const heading = headings.join(',');
        //     csvContent += heading + '\r\n';
        //     csvData.forEach((row) => {
        //         const csvRow = row.join(',');
        //         csvContent += csvRow + '\r\n';
        //     });
        //     const encodedUri = encodeURI(csvContent);
        //     const link = document.createElement('a');
        //     link.setAttribute('href', encodedUri);
        //     link.setAttribute('download', 'shape_n_print_design_n_print_and_print_orders_data.csv');
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        // },
        // async downlaodDesign(alldata) {
        //     const orderStatus = this.orderStatus
        //     let headings = [
        //         'Customer Name',
        //         'Order Date',
        //         'Order Address Title',
        //         'Order Address-1',
        //         'Order Address-2',
        //         'Order City',
        //         'Order State',
        //         'Order Country',
        //         'Order ZIPCODE',
        //         'Payment Status',
        //         'Payment Type',
        //         'Order Status',
        //         'Order Price',
        //         'Order Quantity',
        //         'Design Content File',
        //         'Design Content Description',
        //         'Design Logo Image',
        //         'Design Reference Image',
        //         'Uploaded Files'
        //     ]
        //     const formattedData = alldata.map(e => {
        //         console.log(e);
        //     })
        //     console.log(formattedData);
        //     return
        //     let headings = [
        //         'Customer Name',
        //         'Order Date',
        //         'Order Address Title',
        //         'Order Address-1',
        //         'Order Address-2',
        //         'Order City',
        //         'Order State',
        //         'Order Country',
        //         'Order ZIPCODE',
        //         'Payment Status',
        //         'Payment Type',
        //         'Order Status',
        //         'Order Price',
        //         'Order Quantity',
        //         'Design Content File',
        //         'Design Content Description',
        //         'Design Logo Image',
        //         'Design Reference Image',
        //         'Uploaded Files'
        //     ]
        //     const csvData = await Promise.all(formattedData)
        //     let csvContent = 'data:text/csv;charset=utf-8,';
        //     const heading = headings.join(',');
        //     csvContent += heading + '\r\n';
        //     csvData.forEach((row) => {
        //         const csvRow = row.join(',');
        //         csvContent += csvRow + '\r\n';
        //     });
        //     const encodedUri = encodeURI(csvContent);
        //     const link = document.createElement('a');
        //     link.setAttribute('href', encodedUri);
        //     link.setAttribute('download', 'shape_n_print_design_orders_data.csv');
        //     document.body.appendChild(link);
        //     link.click();
        //     document.body.removeChild(link);
        //     // const formattedData = alldata.filter(e => e.order_type == 'DESIGN').map(e => {
        //     //     let order_data = [
        //     //         e.user.username,
        //     //         new Date(e.order.odate).toLocaleDateString(),
        //     //         e?.address?.add_title ? e?.address?.add_title : 'N/A',
        //     //         e?.address?.add1 ? e?.address?.add1 : 'N/A',
        //     //         e?.address?.add2 ? e?.address?.add2 : 'N/A',
        //     //         e?.address?.city ? e?.address?.city : 'N/A',
        //     //         e?.address?.c_state ? e?.address?.c_state : 'N/A',
        //     //         e?.address?.country ? e?.address?.country : 'N/A',
        //     //         e?.address?.zipcode ? e?.address?.zipcode : 'N/A',
        //     //         e.order.status_payment,
        //     //         e.order.paymenttype,
        //     //         orderStatus.find(elm => elm.id == e.order.status_order).text,
        //     //         e.price,
        //     //         e.qty,
        //     //         e.selected_product.design_images.content_file,
        //     //         e.selected_product.design_images.description,
        //     //         e.selected_product.design_images.logo,
        //     //         e.selected_product.design_images.reference,
        //     //     ]
        //     //     return order_data
        //     // })

        // },
        async exportData() {
            let csvContent = 'data:text/csv;charset=utf-8,';
            if (this.export_data_length > 16) {
                for (let index = 1; index <= this.export_data_length - 16; index++) {
                    this.export_heading.push(`Option ${index}`)
                }
            }
            const heading = this.export_heading.join(',');
            csvContent += heading + '\r\n';
            this.export_data.forEach((row) => {
                const csvRow = row.join(',');
                csvContent += csvRow + '\r\n';
            });
            const encodedUri = encodeURI(csvContent);
            const link = document.createElement('a');
            link.setAttribute('href', encodedUri);
            link.setAttribute('download', 'ShapeNPrintOrderDetails.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        updateStatus(id, status, orderData) {
            if (status == 2 && !this.changeStatusData) {
                this.changeStatusData = {
                    id,
                    status,
                    orderData
                }
                this.selectedOrderForTelyport = orderData
                this.$modal.show(`shipOrder${orderData.oid}`)
                this.getOrderDetail(orderData.oid)
                return
            }
            this.changeStatusData = null
            const status_data = [
                {
                    id: 0,
                    text: 'Pending'
                },
                {
                    id: 1,
                    text: 'Placed'
                },
                {
                    id: 2,
                    text: 'Packed'
                },
                {
                    id: 3,
                    text: 'Shipped'
                },
                {
                    id: 4,
                    text: 'Delivered'
                },
            ]
            var ev = this
            var param = {
                id: id,
                status: status,
                table: 'mss_orders',
                type: 'shippingUpdate'
            }
            const user = orderData.user
            const reciever_email = user.email
            const reciever_full_name = user.username
            const subject = `Order ID - SNP-ORD-${id} has been ${status_data.find(e => e.id == status).text}`
            let msg = ''
            const selectedOrder = this.allData.data.find(e => e.oid == id)
            const categories = selectedOrder.order_details.map(e => {
                if (e.selected_product.product_sub_category) {
                    return {
                        name: e.selected_product.product_sub_category.sub_category_name,
                        quantity: e.qty,
                        price: e.price
                    }
                } else {
                    return {
                        name: e.selected_product.product_category.category_name,
                        quantity: e.qty,
                        price: e.price
                    }
                }
            })
            msg = `
            <h3>Order Details (Order ID - ${id})</h3>
            <table style="font-family: Arial, Helvetica, sans-serif; border-collapse: collapse;width: 100%;">
                <thead>
                    <th style="padding-top: 12px;padding-bottom: 12px;text-align: center;background-color: #04AA6D;color: white;">
                        #
                    </th>
                    <th style="padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #04AA6D;color: white;">
                        Name
                    </th>
                    <th style="padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #04AA6D;color: white;">
                        Quantity
                    </th>
                    <th style="padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #04AA6D;color: white;">
                        Price
                    </th>
                    <th style="padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: #04AA6D;color: white;">
                        Status
                    </th>
                </thead>
                <tbody>
                    `
            categories.forEach((e, i) => {
                msg += `<tr>
                    <td style="padding-top: 12px;padding-bottom: 12px;text-align: center;background-color: white;color: black;">
                        ${i + 1}
                    </td>
                    <td style="padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: white;color: black;">
                        ${e.name}
                    </td>
                    <td style="padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: white;color: black;">
                        ${e.quantity}
                    </td>
                    <td style="padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: white;color: black;">
                        ${e.price}
                    </td>
                    <td style="padding-top: 12px;padding-bottom: 12px;text-align: left;background-color: white;color: black;">
                        ${status_data.find(e => e.id == status).text}
                    </td>
                </tr>`
            })
            msg += `</tbody>
            </table>
            `

            const data = {
                reciever_email,
                reciever_full_name,
                subject,
                msg,
            }
            if (user.mobile != '' || !user.mobile) {
                const payload_data = {
                    status: status_data.find(e => e.id == status).text,
                    order_id: `SNP-ORD-${id}`,
                    phone_number: `91${user.mobile}`,
                    type: 'send_update'
                }
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: payload_data
                }).then(function (response) {
                    if (response) {
                        ev.$toasted.global.success({
                            message: 'Order Status Updated Successfully'
                        })
                    }
                })
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
                if (response) {
                    ev.$toasted.global.success({
                        message: 'Order Status Updated Successfully'
                    })
                }
                axios({
                    method: 'POST',
                    url: ev.$root.URL_ROOT + 'checkmail.php',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    data: data
                }).then(response => {
                    console.log(response);
                })
                ev.allDatas()
            })
        },
        update(table, status, id) {
            var param = {
                id: id,
                status: status,
                table: table,
                type: 'commonStatus'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
                var data = response.data;
                console.log('status', data)
            })
        },
        addInit() {
            this.getUnderof();
            this.reset()
        },
        editInit() {
            this.getDetail();
            this.getUnderof();
        },
        viewInit() {
            this.viewAllUrl = this.URL_ROOT + 'admin/' + this.page + '/all'
            this.allDatas('pending')
        },
        reset() {
            this.form = {
                id: null,
                status: true,
                type: 'add_user',
                username: '',
                email: '',
                mobile: '',
                pass: '',
                state: '',
                city: '',
                zip: '',
            };
        },
        getUnderof() {
            var pList = [];
            pList.push({
                label: 'Primary Menu',
                code: 0
            })
            $.ajax({
                "method": 'GET',
                "url": this.URL_ROOT + 'admin/' + this.page + '/allpage/?field=heading,id,underof',
                "success": (response) => {
                    if (response.status == "success") {
                        console.log(response.data);
                        $.each(response.data, function (key, param) {
                            //console.log(param,key);
                            pList.push({
                                label: param.heading,
                                code: param.id
                            })
                        })
                    }
                    this.pageList = pList;
                }
            })
            /**
             if(this.action=="add"){
                this.from.lorder = response.length+1;
            } */
        },
        getDetail() {
            var ev = this
            var param = {
                uid: this.id,
                type: 'userDetail'
            }
            axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'api.php',
                data: param
            }).then(function (response) {
                console.log(response.data.data)
                var data = response.data;
                ev.form = data.data
            })
        },
        async getOrderDetail(id) {
            var ev = this
            var param = {
                ord_id: id,
                type: 'fetchOrdersAdmin',
            }
            const resp = await axios({
                method: 'POST',
                url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                data: param
            })
            console.log(resp);
        },
        async allDatas(status) {
            this.loader = true
            this.orderStatus = status

            try {
                const response = await axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'updatedApiForProducts.php',
                    data: { type: 'fetchOrdersAdmin' }
                })

                // -------------------------------
                // 1️⃣ Normalize API response
                // -------------------------------
                let ordersArray = []

                if (Array.isArray(response.data?.data)) {
                    ordersArray = response.data.data
                } else if (typeof response.data?.data === 'object' && response.data.data !== null) {
                    ordersArray = Object.values(response.data.data)
                }

                // -------------------------------
                // 2️⃣ Normalize orders & products
                // -------------------------------
                ordersArray = ordersArray.map(order => {
                    const validDetails = Array.isArray(order.order_details)
                        ? order.order_details.filter(d => d?.pid != null)
                        : []

                    return {
                        ...order,
                        order_details: validDetails.map(item => ({
                            ...item,
                            selected_product: item.selected_product || {
                                product_images: [],
                                product_options: [],
                                product_option_values: [],
                                product_category: null,
                                product_sub_category: null
                            }
                        })),
                        collapsable: validDetails.length > 1,
                        collaps: false
                    }
                })

                const data = {
                    status: response.data.status,
                    data: ordersArray
                }

                this.tempData = data
                this.allData = data
                this.export_data = []
                this.export_data_length = 0

                // -------------------------------
                // 3️⃣ Build export data safely
                // -------------------------------
                for (const element of data.data) {
                    for (const item of element.order_details) {
                        const productName =
                            item.selected_product?.product_sub_category?.sub_category_name ||
                            item.selected_product?.product_category?.category_name ||
                            'N/A'

                        const row = [
                            item.order_type || 'N/A',
                            element.user?.fullname || 'N/A',
                            new Date(element.odate).toLocaleDateString(),
                            item.address?.add_title || 'N/A',
                            item.address?.add1 ? item.address.add1.replaceAll(',', '-') : 'N/A',
                            item.address?.add2 ? item.address.add2.replaceAll(',', '-') : 'N/A',
                            item.address?.city || 'N/A',
                            item.address?.c_state || 'N/A',
                            item.address?.country || 'N/A',
                            item.address?.zipcode || 'N/A',
                            element.status_payment || 'N/A',
                            element.paymenttype || 'N/A',
                            this.orderStatuses.find(e => e.id === element.status_order)?.text || 'N/A',
                            `₹ ${parseFloat(item.price || 0).toFixed(2)}`,
                            `${item.qty || 0}`,
                            productName
                        ]

                        // Add product options (if any)
                        item.selected_product.product_options.forEach(opt => {
                            const val = item.selected_product.product_option_values
                                .find(v => v.opt_id === opt.id)?.name || 'N/A'
                            row.push(`${opt.name}: ${val}`)
                        })

                        this.export_data_length = Math.max(this.export_data_length, row.length)
                        this.export_data.push(row)
                    }
                }

            } catch (error) {
                console.error('API Error:', error)
                // this.$toasted.global.error({ message: 'Failed to fetch orders' })
            } finally {
                this.loader = false
            }
        },


        submit() {
            var ev = this

            if (this.form.username === '') {
                this.$toasted.global.error({
                    message: 'Please enter Full Name'
                })
            } else if (this.form.email === '') {
                this.$toasted.global.error({
                    message: 'Please enter Email'
                })
            } else if (this.form.mobile === '') {
                this.$toasted.global.error({
                    message: 'Please enter mobile'
                })
            } else if (this.form.pass === '') {
                this.$toasted.global.error({
                    message: 'Please enter password'
                })
            } else if (this.form.state === '') {
                this.$toasted.global.error({
                    message: 'Please enter State'
                })
            } else if (this.form.city === '') {
                this.$toasted.global.error({
                    message: 'Please enter City'
                })
            } else if (this.form.zip === '') {
                this.$toasted.global.error({
                    message: 'Please enter Pincode'
                })
            } else {
                var status = ''
                if (ev.form.status == true) {
                    status = 1
                } else {
                    status = 0
                }
                let formData = new FormData();
                if (this.action == 'edit') {
                    this.form.type = 'edit_user';
                    formData.append('uid', this.id);

                }
                formData.append('fullname', ev.form.username);
                formData.append('mobile', ev.form.mobile);
                formData.append('email', ev.form.email);
                formData.append('password', ev.form.pass);
                formData.append('state', ev.form.state);
                formData.append('city', ev.form.city);
                formData.append('pincode', ev.form.zip);
                formData.append('status', status);
                formData.append('type', ev.form.type);
                axios({
                    method: 'POST',
                    url: this.$root.URL_ROOT + 'api.php',
                    data: formData
                }).then(function (response) {
                    var data = response.data;
                    console.log(response)
                    if (data.status == "success") {
                        ev.$swal({
                            toast: true,
                            position: 'top-end',
                            timer: 5000,
                            icon: 'success',
                            timerProgressBar: true,
                            title: 'Action perform successfully'
                        })
                        ev.$router.push({
                            name: 'index',
                            params: {
                                page: ev.page,
                            }
                        })
                    } else {
                        setTimeout(() => ev.$swal(data.msg), 1000);
                    }
                })
            }
        },
        remove(id) {
            var self = this;
            var param = {
                id: id,
                table: 'mss_site_user',
                type: 'commonDelete'
            }
            this.$swal({
                title: "Delete this ?",
                text: "Are you sure? You won't be able to revert this!",
                icon: 'info',
                showCancelButton: true,
                confirmButtonColor: "#f00",
                confirmButtonText: "Yes, Delete it!",
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    axios({
                        method: 'POST',
                        url: this.$root.URL_ROOT + 'api.php',
                        data: param
                    }).then(function (response) {
                        var data = response.data;
                        self.allDatas()
                        console.log('commonDelete', data)
                    })
                }
            })
        },
        async getFileBinary(url) {
            try {
                console.log(`${this.$root.URL_ROOT}fetchFile.php?url=${encodeURIComponent(url)}`);
                const response = await fetch(`${this.$root.URL_ROOT}fetchFile.php?url=${encodeURIComponent(url)}`);
                console.log(response);
                if (!response.ok) {
                    throw new Error('Failed to fetch file');
                }
                return await response.blob();
            } catch (error) {
                console.error('Error fetching file:', error);
                return null;
            }
        },

        async downloadFile(fileUrl) {
            try {
                console.log(`${this.$root.URL_ROOT}fetchFile.php?url=${encodeURIComponent(fileUrl)}`);
                const response = await fetch(`${this.$root.URL_ROOT}fetchFile.php?url=${encodeURIComponent(fileUrl)}`);
                console.log(response);
                if (!response.ok) {
                    throw new Error('Failed to fetch file');
                }
                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = fileUrl.split('/').pop(); // Change the filename if needed
                link.click();
                URL.revokeObjectURL(url); // Clean up
            } catch (error) {
                console.error('Error downloading image:', error);
            }
        }
    },
    mounted() {
        if (localStorage.getItem('permissions')) {
            const permissionsLS = localStorage.getItem('permissions')
            const permission = JSON.parse(permissionsLS)
            this.permissions = permission.filter(e => e.section == 'ORDER' && e.has_permission == true)
        }
        if (this.action == "view") {
            this.viewInit()
        } else if (this.action == "edit" && this.id > 0) {
            this.editInit()
        } else if (this.action == "add") {
            this.addInit();
        }
    },
    watch: {
        'action': function (val) {
            if (val == "view") {
                this.viewInit()
            } else if (val == "edit" && this.id > 0) {
                this.editInit()
            } else if (val == "add") {
                this.addInit();
            }
        },
        // 'form.linkname': function() {
        //     //var text = val.replace(' ', "+")
        //     //this.form.linkname = this.limitedword(text.replace(/\W/g, "+"),20);
        // },'form.pbody': function(val) {
        //     if(this.defaultSEO){
        //         this.form.meta_description = this.limitedword(this.striphtml(val),150);
        //     }
        // },
        // 'form.heading': function(val) {
        //     if(this.defaultSEO){
        //         this.form.meta_title = this.limitedword(val,20);
        //     }
        // },
        // 'loading': function(val) {
        //     if(val){
        //         this.$swal.showLoading();
        //     }else{
        //         this.$swal.close()
        //     }
        // },
        // 'q': function(newVal,oldVal) {
        //     if(newVal==''){
        //         this.viewAllUrl = this.URL_ROOT+'admin/'+this.page+'/all';
        //     }else if(newVal!=oldVal){
        //         this.viewAllUrl = this.URL_ROOT+'admin/'+this.page+'/all/'+newVal;
        //     }
        //     this.allDatas(false);
        // }
    }
}
</script>

<style scoped>
@import "~vue2-editor/dist/vue2-editor.css";

/* .table td,
.table th {
    white-space: unset !important;
} */

.address-heading {
    background: #05A677;
    color: #fff;
    padding: 10px;
}

.link {
    color: #fff !important;
}

td {
    width: max-content !important;
}

th {
    width: max-content !important;
}

.loader {
    width: 48px;
    height: 48px;
    border: 5px solid #FFF;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
